import React from 'react';

type Props = {
  avif?: string;
  webp?: string;
  src: string;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
  fill?: boolean; // if true, position absolute to fill parent
  width?: number | string;
  height?: number | string;
  loading?: 'lazy' | 'eager' | 'auto';
};

export default function ResponsiveImage({ avif, webp, src, alt = '', className, style, fill, width, height, loading }: Props){
  const baseImgStyle: React.CSSProperties = {
    display: 'block',
    maxWidth: '100%',
    // do not set height here so Tailwind `h-...` classes can take effect
    ...style,
  };

  if (fill) {
    const fillImgStyle: React.CSSProperties = {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
      pointerEvents: 'none',
      ...style,
    };

    return (
      <picture style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }} aria-hidden>
        {avif && <source type="image/avif" srcSet={avif} />}
        {webp && <source type="image/webp" srcSet={webp} />}
        <source type="image/jpeg" srcSet={src} />
        <img src={src} alt={alt} className={className} style={fillImgStyle} loading={loading ?? 'lazy'} width={"100%"} height={"100%"} />
      </picture>
    );
  }

  return (
      <picture>
      {avif && <source type="image/avif" srcSet={avif} />}
      {webp && <source type="image/webp" srcSet={webp} />}
      <source type="image/jpeg" srcSet={src} />
      <img
        src={src}
        alt={alt}
        className={className}
        style={baseImgStyle}
        loading={loading ?? 'lazy'}
        {...(width ? { width } : {})}
        {...(height ? { height } : {})}
      />
    </picture>
  );
}
